import React from 'react';
import {
  AppBar,
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from '@mui/material';
import { Menu as MenuIcon, ExitToApp as LogoutIcon } from '@mui/icons-material';
import { Context } from '../context/DataContext';

const drawerWidth = 240;

const Header = (props) => {
  const { window, handleLogout } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { state } = React.useContext(Context);
  const tokenLogin = state?.loginInfo?.tokenLogin;
  const tokenAttempted = state?.loginInfo?.tokenAttempted;
  const isTokenMode = tokenLogin || tokenAttempted;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar component="nav">
        <Toolbar sx={{ justifyContent: isTokenMode ? 'center' : 'flex-start' }}>
          {
            !isTokenMode ? (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>

            ) : null
          }
          <Typography variant="h6" noWrap sx={{ textAlign: isTokenMode ? 'center' : 'left' }}>
            {isTokenMode ? '購買延保' : '行動保險(立格)'}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <Toolbar />
            <Divider />
            <List>
              <ListItem
                button
                onClick={() => {
                  handleDrawerToggle();
                  handleLogout();
                }}
              >
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText primary="登出" />
              </ListItem>
            </List>
          </Box>
        </Drawer>
      </Box>
    </Box>
  );
};

export default Header;
